var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"js-gke-cluster-creation-submit btn btn-success",attrs:{"type":"submit","disabled":!_vm.hasValidData}},[_vm._v("\n  "+_vm._s(_vm.s__('ClusterIntegration|Create Kubernetes cluster'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }